import * as React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {IHomeContentBoxDataItem, IHomeListItem} from "../../model/IHomeListItem";
import {SharedDocument} from "../../model/SharedDocument.model";
import {Card} from "../common/Card";
import {defaultCardTitleStyle} from "../common/cardStyles";
import {Brackets, BracketsBox} from "../base/Brackets.component";
import {HomeContentBox} from "./HomeContentBox.component";
import {SharedDocumentApi} from "../../api/SharedDocumentApi";
import {useEffect, useState} from "react";

class CardData {
    constructor(public title: string, public cardText: string, public link: string, public id: string) {
    }
}

export const ATC_SHARED_DESCRIPTION = "Aon Collective Investment Trust (“ACIT”) Fund Documents";
export const ATC_SHARED_DOC = "ACIT Shared Documents";

const trustCompanySharedDocumentData = new CardData(
    ATC_SHARED_DESCRIPTION,
    ATC_SHARED_DOC,
    "/shared-documents",
    "home-card-shared-documents",
);

export const ATC_DISCLAIMER_P1 = "Aon Trust Company LLC (ATC), an Illinois non-depository, state-chartered bank, is the Trustee\n" +
    "              for the Aon Collective Investment Trust (“ACIT”). The ACIT Funds are collective investment trust funds –\n" +
    "              they are not mutual funds, are not FDIC insured, nor registered with the U.S. Securities and Exchange\n" +
    "              Commission, and not guaranteed by ATC, any affiliate or any government agency.  This is not an offer to\n" +
    "              sell or the solicitation of an offer to purchase a beneficial interest in the Funds. Please read the\n" +
    "              ACIT Offering Statement and any other supplements and disclosure documents for important information.";

export const ATC_DISCLAIMER_P2 = "The documents provided are for the use of plan sponsors and their intermediaries. They are not intended\n" +
    "              for use and/or distribution to the general public.";

export interface IAtcHomeProps {
    sharedDocumentsEnabled: boolean;
}

export const AtcHome: React.FunctionComponent<IAtcHomeProps> = (props) => {
    const [sharedDocuments, setSharedDocuments] = useState<SharedDocument[]>([]);

    const getSharedDocuments = () => {
        if (props.sharedDocumentsEnabled) {
            SharedDocumentApi.requestRecentSharedDocuments().then((response) => {
                setSharedDocuments(response.data!);
            });
        }
    };

    useEffect(() => {
        getSharedDocuments();
    },[]);

    const itemList = (dataList: IHomeListItem[]):IHomeContentBoxDataItem[] => {
        return dataList.map((it) => it.transform());
    };

    const renderSharedDocumentsCard = (cardData: CardData) => {
        if (props.sharedDocumentsEnabled) {
            return <Card
                className="atc-home__card-container"
                headerContainerStyle={defaultCardTitleStyle}
                header={<FormattedMessage id={`home.${cardData.id}-title`} defaultMessage={cardData.title}/>}
                expanded={true}>
                <Link className="atc-home__card-link" to={cardData.link}>
                    <div id={cardData.id} className="atc-home__card-text">
                        <FormattedMessage id={`home.${cardData.id}-desc`} defaultMessage={cardData.cardText}/>
                        <div className="navigation__forward-arrow-small fa-regular fa-arrow-right"/>
                    </div>
                </Link>
            </Card>;
        }
        return null;
    };

    const renderSharedDocuments = () =>  {
        if (props.sharedDocumentsEnabled) {
            return <div className="atc-home__documents-list" data-testid="atc-home__documents-list">
                <Brackets>
                    <BracketsBox className="box-margin">
                        <HomeContentBox title="New Documents"
                            translationId="new-documents"
                            values={itemList(sharedDocuments)}
                            shouldTitlesBeLinks={false}
                            shouldDocumentsDownload={true}/>
                    </BracketsBox>
                </Brackets>
            </div>;
        }
        return null;
    };

    const renderDisclaimer = () => {
        return <div className="atc-home__content-atc-disclaimer" data-testid="atc-home__content-atc-disclaimer">
            {ATC_DISCLAIMER_P1}
            <p>{ATC_DISCLAIMER_P2}</p>
            </div>;
    };

    const  renderContent = () => {
        return <div className="new-common-styles page-min-width-1024 atc-home__container"
                    data-testid="atc-home__container">
            <div className="home-top-spacer" data-testid="home-top-spacer"/>
            <div className="atc-home__cards">
                {renderSharedDocumentsCard(trustCompanySharedDocumentData)}
            </div>
            {renderSharedDocuments()}
            {renderDisclaimer()}
        </div>;
    };

    return renderContent();
};
